/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { instanceOfFxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultFacebookGamesMerchantData, FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultFacebookGamesMerchantDataFromJSONTyped, FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultFacebookGamesMerchantDataToJSON, } from './FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultFacebookGamesMerchantData';
export function FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultFacebookGamesFromJSON(json) {
    return FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultFacebookGamesFromJSONTyped(json, false);
}
export function FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultFacebookGamesFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultFacebookGamesMerchantData(json)) {
        return FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultFacebookGamesMerchantDataFromJSONTyped(json, true);
    }
    return {};
}
export function FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultFacebookGamesToJSON(json) {
    return FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultFacebookGamesToJSONTyped(json, false);
}
export function FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultFacebookGamesToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    if (instanceOfFxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultFacebookGamesMerchantData(value)) {
        return FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultFacebookGamesMerchantDataToJSON(value);
    }
    return {};
}
//# sourceMappingURL=FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultFacebookGames.js.map